enum RegionTypes {
  SET_REGION_LOADING = 'SET_REGION_LOADING',
  SET_REGION_SUCCESS = 'SET_REGION_SUCCESS',
  SET_REGION_ERROR = 'SET_REGION_ERROR',
  RESET_REGION_STATE = 'RESET_REGION_STATE',
}

export default RegionTypes;
